


















import { Vue, Component } from "vue-property-decorator";
import { currentScoutingStore } from "@/store/typed";

@Component
export default class Show extends Vue {
  get id() {
    return this.$route.params.id;
  }

  get scoutingArea() {
    return currentScoutingStore.scoutingAreas.find((o) => this.id === o.id);
  }

  get scouting() {
    return currentScoutingStore.scouting;
  }

  back() {
    currentScoutingStore.centerOnAllObjects();
    this.$router.go(-1);
  }
}
